export const FILES_TO_HIDE = ['.Brief'];
